export default (to, from, next) => {
    //console.log(to.path)
    if (sessionStorage.getItem("token") != null && sessionStorage.getItem("token").length > 0) {
      next()
    } else {
        next('/login')
    }
}